import { createAction } from 'redux-actions'
import { get, identity } from 'lodash/fp'
import { Action, ThunkAction } from '../types/common'
import { query } from '../common/api'
import { PUBLISHED_MESSAGE_QUERY, MARK_READ_MUTATION } from './messagesQueries'
import { IMessage } from '../types/message'
import { messageSelector } from './messagesSelectors'

export const SET_MESSAGE = 'MESSAGES/SET_MESSAGE'
export type SET_MESSAGE = Action<IMessage | null>
export const setMessage = createAction<IMessage | null, IMessage | null>(
  SET_MESSAGE,
  identity,
)

export const requestPublishedMessage =
  (): ThunkAction<Promise<void>> => async (dispatch) => {
    const message = get(
      'publishedMessage',
      await query(PUBLISHED_MESSAGE_QUERY),
    )
    dispatch(setMessage(message))
  }

export const markMessageAsRead =
  (id: number): ThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    await query(MARK_READ_MUTATION, { id })
    const currentMessage = messageSelector(getState())
    if (currentMessage && currentMessage.id === id) {
      dispatch(setMessage({ ...currentMessage, read: true }))
    }
  }
